import {
  createSearchAndFilterDisplayOptions,
  getDefaultRequestFields,
  mapLoyaltyEducation,
  mapMessages,
  mapOmnitureData,
  mapPropertySearchResults,
  mapSearchedDestination,
  mapSortAndFilter
} from 'stores/adapters';
import { mapMap } from 'src/common/stores/adapters/bex-api/search/map-adapter';

import { HotelResultsViewModel } from 'models';

import { LodgingPwaPropertySearch, OperationResult } from '__generated__/api';

export const adaptPropertySearch = (bexApiResults: OperationResult<LodgingPwaPropertySearch.Query>): HotelResultsViewModel => {
  const { data, extensions } = bexApiResults;

  if (!data || !data.propertySearch) {
    return {};
  }

  const { propertySearch } = data;

  const { summary } = propertySearch;

  const loyaltyInfo = summary && summary.loyaltyInfo;

  return {
    defaultRequestFields: getDefaultRequestFields(
      propertySearch.searchCriteria,
      propertySearch.shoppingContext && propertySearch.shoppingContext.multiItem && propertySearch.shoppingContext.multiItem.id,
      bexApiResults
    ),
    exitIntent: propertySearch && propertySearch.exitIntent,
    hotels: mapPropertySearchResults(data),
    loyaltyEducation: mapLoyaltyEducation(summary),
    loyaltyMessagingModel: loyaltyInfo && {
      loyaltyPointsMessage: loyaltyInfo.saveWithPointsMessage,
      swpActionMessage: loyaltyInfo.saveWithPointsActionMessage
    },
    map: mapMap(data),
    messages: mapMessages(summary),
    multiItemSearchContext: propertySearch.multiItemSearchContext,
    omnitureData: mapOmnitureData(extensions.analytics),
    resultSectionHeadings: summary && summary.resultSectionHeadings,
    searchAndFilterDisplayOptions: createSearchAndFilterDisplayOptions(propertySearch.sortAndFilter),
    searchedDestination: mapSearchedDestination(data),
    sortAndFilter: mapSortAndFilter(data.propertySearch),
    resultsSummary: summary && summary.resultsSummary,
    resultsHeading: summary && summary.resultsHeading,
    intentMedia: propertySearch.lodgingIntentMedia,
    totalPropertyCount: summary && summary.matchedPropertiesSize
  };
};
